/**
 * In-memory log of API requests and responses for the developer panel.
 * Recording is manual (start/stop). Max entries cap to avoid slowness/crashes.
 */

export const MAX_ENTRIES = 100;

let entries = [];
let isRecording = false;
const listeners = new Set();

export function getState() {
  return { entries: [...entries], isRecording };
}

function notify() {
  const state = getState();
  listeners.forEach((fn) => fn(state));
}

export function getIsRecording() {
  return isRecording;
}

export function startRecording() {
  if (isRecording) return;
  isRecording = true;
  notify();
}

export function stopRecording() {
  if (!isRecording) return;
  isRecording = false;
  notify();
}

export function addEntry(entry) {
  if (!isRecording) return;
  entries.unshift(entry);
  if (entries.length > MAX_ENTRIES) entries.length = MAX_ENTRIES;
  notify();
}

export function updateEntry(id, updates) {
  const i = entries.findIndex((e) => e.id === id);
  if (i === -1) return;
  entries[i] = { ...entries[i], ...updates };
  notify();
}

export function getEntries() {
  return [...entries];
}

export function clear() {
  entries = [];
  notify();
}

export function subscribe(fn) {
  listeners.add(fn);
  fn(getState());
}

export function unsubscribe(fn) {
  listeners.delete(fn);
}
